<template>
  <div class="overlay-header" :class="[{right: theme === 'desktop'}, `theme-${theme}`]" :style="style">
    <div class="overlay-header-wrapper">
      <div @click="closeOverlay" class="overlay-back-wrapper">
        <svg-icon-cancel v-if="theme === 'desktop'" class="overlay-back-btn" fill="#FFF" width="32" height="32"></svg-icon-cancel>
        <svg-icon-arrow-left v-else class="overlay-back-btn" fill="#FFF"></svg-icon-arrow-left>
      </div>
      <div class="overlay-header-meta">
        <field-section class="overlay-header-section" v-if="sections.length" :sections="sections"></field-section>
        <div class="overlay-header-title">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>

  import forEach from 'lodash/forEach'
  import get from 'lodash/get'
  import map from 'lodash/map'

  import FieldSection from 'components/node/fields/Section.vue'
  import SvgIconArrowLeft from 'static/svg/icon_arrow_left.svg'
  import SvgIconCancel from 'static/svg/icon_cancel.svg'
  import { mapActions } from 'vuex'

  export default {
    name: 'person-overlay-header',
    components: {
      FieldSection,
      SvgIconArrowLeft,
      SvgIconCancel,
    },
    props: {
      nid: [Number, String],
      overlayBody: {
        type: Object,
        default: () => ({}),
      },
      theme: {
        type: [String, Boolean],
        default: '',
      },
      width: {
        type: String,
      },
    },
    methods: {
      ...mapActions([
        'toggleRelatedPersonOverlay',
      ]),
      closeOverlay() {
        window.location.hash = ''
      },
    },
    computed: {
      style() {
        const width = this.theme === 'desktop' && this.width ? this.width : '100%'
        return { width }
      },
      label() {
        const label = get(this, 'node.short_title', get(this, 'node.title', ''))
        return label
      },
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
      mode() {
        return get(this, 'overlayBody.headerMode', '')
      },
      sections() {
        const sections = []
        forEach(get(this, 'node.sections', []), (sectionLineage) => {
          const sectionList = map(sectionLineage, this.$store.getters.term)
          sections.push(sectionList)
        })
        return sections
      },
    },
  }
</script>

<style lang="scss" scoped>
  .overlay-header {
    @include respond-to('desktop') {
      max-width: rem-calc(640);
    }
    padding: rem-calc(0 10);
    background-color: $cool-black;
    transition: all .2s ease, transform .4s ease .02s;
    position: fixed;
    z-index: 1200;
    width: 100%;
    top: 0;

    &.right {
      right: 0;
    }

    &.collapse {
      padding: rem-calc(8 6);
      background-color: $black;
      .overlay-header-section {
        font-size: rem-calc(11);
        line-height: rem-calc(13);
      }
      .overlay-back-btn{
        width: rem-calc(12);
        height: rem-calc(11);
      }
    }

    .overlay-header-wrapper {
      padding: rem-calc(7 6);
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      display: flex;
      border-bottom: rem-calc(1) solid $white-40;
    }

    .overlay-header-title {
      color: $white;
      font-family: $bungee;
      font-size: rem-calc(18);
      line-height: rem-calc(18);
    }

    .overlay-header-meta {
      flex-direction: column;
      align-items: flex-end;
    }

    .overlay-back-wrapper,
    .overlay-header-meta,
    .overlay-header-title,
    .overlay-header-section{
      display: flex;
    }

    .overlay-header-section {
      font-size: rem-calc(14);
      line-height: rem-calc(16);
      font-weight: bold;
      color: $white;
      text-transform: uppercase;
      margin-bottom: rem-calc(2);
    }

    &.theme-desktop {
      transition: all .4s ease .02s;
      padding: rem-calc(0 30 0 26);
      .overlay-header-wrapper {
        padding: rem-calc(12 0 14);
      }
      .overlay-header-section {
        font-size: rem-calc(20);
        line-height: rem-calc(24);
        margin-bottom: 0;
        font-weight: bold;
      }
      .overlay-header-title {
        font-size: rem-calc(24);
        line-height: rem-calc(24);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?3673ccf6